import { OnInit, Component, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { KeywordQueries, ICustomer, Request } from "graphql/queries/keyword.queries"
import { Subscription } from "rxjs"
import { RequestActivationMethod } from '../../../graphql/queries/keyword.queries'
import { RequestMutations } from "src/graphql/mutations/request.mutations"
import { VideoFormComponent } from 'modules/keywords/video-form/video-form.component'
import sweetAlert from 'bmAlert'
import { updateCustomersNavRequestsCount } from '../utils'
import { CustomerActions } from 'src/actions/customer-actions'

@Component({
  template: `
  <keywords-layout>
    <div class="row">
      <div class="col-md-12">
        <h5>View Request</h5>
      </div>
    </div>
    <hr class="no-top-buffer tiny-bottom-buffer">
    <div *ngIf="customer">
      <video-form
        class="small-horizontal-buffer bottom-buffer"
        (save)="saveVideoRequest($event)"
        (cancel)="onCancel()"
        (delete)="onDelete($event)"
        [customer]="customer"
        [request]="request"
        [viewOnly]="requestActive"
      ></video-form>
    </div>
  </keywords-layout>
  `
})
export class EditRequestPage implements OnInit {
  // Inputs/Outputs & other decorator properties
  // properties
  @ViewChild(VideoFormComponent) public videoForm: VideoFormComponent;
  customerRouteObs: Subscription;
  requestRouteObs: Subscription;
  customerId: number;
  requestId: number;
  contentTypeId: number = 99;
  customer: ICustomer;
  request: Request;
  loading: boolean = true;

  // constructor
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private keywordQueries: KeywordQueries,
    private requestMutations: RequestMutations,
    private customerActions: CustomerActions
  ) {}
  // ng lifecycle hooks
  ngOnInit(): void {
    this.customerRouteObs = this.route.parent.parent.params.subscribe(params => {
      this.customerId = +params['customerId']
      this.requestRouteObs = this.route.params.subscribe(params => {
        this.requestId = +params['requestId']
        if (this.customerId && this.requestId) {
          this.keywordQueries.editRequestPageQuery(this.customerId, this.requestId).subscribe(({ loading, data }) => {
            this.loading = loading
            if (data) {
              this.customer = data.customer
              this.request = data.customer.request
            }
          })
        }
      })
    })
  }
  // getters
  // methods used in the template
  get requestActive(): boolean {
    return ['new', 'active', 'viewed', 'fulfilled'].includes(this.request.state)
  }

  onCancel(): void {
    this.router.navigate(['../../../'], { relativeTo: this.route, queryParams: { state: this.request.state } })
  }

  onDelete({request}: {request: Request}): void {
    const customerId = this.customerId
    const id = request.id

    sweetAlert.confirm({title: 'Delete Request?', text: 'Are you sure?'}).then(confirm => {
      if (confirm) {
        this.requestMutations.deleteRequest({ customerId, id }).then(data => {
          if (data) {
            updateCustomersNavRequestsCount(data, this.customerActions)
          }
          this.videoForm.form.reset()
          this.router.navigate(['../../../'], { relativeTo: this.route, queryParams: { state: request.state } })
        })
      }
    })
  }

  // private methods used only in the class, instead of the `private` keyword, using `_method` pattern (easier for testing)
  // explicitly public methods (called from other parent components)

  // this is mostly the same as NewKeywordPage createVideoRequest
  saveVideoRequest({request, activationMethod}: {request: Request, activationMethod?: RequestActivationMethod}): void {
    const inputObj = {
      customerId: this.customerId,
      request: { ...request, type: 'VideoRequest' as 'VideoRequest' },
      activationMethod
    }
    this.requestMutations.createOrUpdateRequest(inputObj).then(data => {
      const state = data.request.state
      let title
      let text
      let buttonText

      if (state === 'active') {
        title = "You've activated a new request!"
        text = "Sit tight, our team is crafting your Verblio Vid. You can expect a draft to review within 72 hours."
        buttonText = "Great!"
      }

      else if (state === 'draft') {
        title = "You've saved a draft."
        text = "But remember, our team won't see your request until you come back and activate it."
        buttonText = "Okay"
      }

      this.videoForm.form.reset()
      this.videoForm.submitting = false
      this.router.navigate(['../../../'], {relativeTo: this.route, queryParams: { state: state }})
      sweetAlert.success({
        title,
        text,
        confirmButtonText: buttonText
      })

      // Remove after customers nav uses graphql
      if (data) updateCustomersNavRequestsCount(data, this.customerActions)
    }).catch(error => {
      this.videoForm.submitting = false
    })
  }

}
